<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title :class="['title', 'red', 'white--text']" v-html="$lang.errorDialogTitle" />
      <v-card-text v-html="$lang.httpErrorMessage" />
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn aria-label="close" dark v-html="$lang.ok" @click="dialog = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ErrorDialog',
  data () {
    return {
      dialog: false
    }
  },
  props: {
    /**
     * Titlebar and close button color
     * @string
     */
    color: {
      type: String,
      required: false,
      default: 'red'
    }
  },
  created () {
    this.$root.$on(this.$events.error, () => {
      this.dialog = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/error-dialog.vue